import React, { Component } from 'react';
import { Trans, i18nMark, withI18n } from 'lingui-react';

import { Button } from './Button/index';
import { CommentInput } from './CommentInput/index';
import { CommentItem } from './CommentItem/index';

import questionItem from '../../../../assets/images/questionItem.svg';

import './questionItem.css';

class QuestionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: !this.props.answer ? false : true,
      isShowComment: false,
      isShowCommentItem: true,
      commentContent: '',
    }
  }

  componentDidMount() {
  }


  handleClickComment = () => {
    this.setState({
      commentContent: this.props.comment
    })
    this.setState({ isShow: !this.state.isShow, isShowComment: !this.state.isShowComment, isShowCommentItem: false })
  }

  handleClickCancel = () => {
    this.setState({
      commentContent: ''
    })
    this.setState({ isShow: true, isShowComment: false, isShowCommentItem: true })
  }

  onChangeTextarea = (e) => {
    this.setState({
      commentContent: e.target.value
    })
  }

  handleClickAnswerQuestion = (e) => {
    this.props.handleClick(e);
    this.setState({
      isShow: true
    })
  }

  deleteComment = (e) => {
    this.setState({
      commentContent: ''
    }, () => {
      this.props.handleSave(e, this.props.questionId, '');
    })
  }

  handleSave = (e) => {
    this.props.handleSave(e, this.props.questionId, this.state.commentContent);
    this.setState({
      commentContent: '',
    })
    this.handleClickCancel();
  }

  render() {
    return (
      <div className="question-item-container">
        <div className="row">
          <div className="col-12 no-padding d-flex flex-row">
            <img className="img-bubble" src={questionItem} alt="" />
            <p className="question-title">
              <Trans id="Question" /> {this.props.categoryCode}-{this.props.topicIndex}.{this.props.no}
            </p>
          </div>
          <div className="col-12 question-right-content">
            <p className="question-content">{this.props.questionContent}</p>
            {
              this.props.explanation ? <div className="question-hint">
                <p className="question-hint-content"><strong><Trans id="Note:" /> </strong> {this.props.explanation}</p>
              </div> : ''
            }

            <div className="col-12 d-flex justify-content-center justify-content-sm-start question-group-button">
              <Button
                styleButton="button-question"
                onClick={this.handleClickAnswerQuestion}
                isActive={this.props.answer === 'yes'}
                type="question"
                icon={this.props.answer === 'yes'}
                text={<Trans id="Yes" />}
                name="yes"
                questionId={this.props.questionId}
              />
              <Button
                styleButton="button-question"
                onClick={this.handleClickAnswerQuestion}
                isActive={this.props.answer === 'partly'}
                icon={this.props.answer === 'partly'}
                type="question"
                text={<Trans id="Partly" />}
                name="partly"
                questionId={this.props.questionId}
              />
              <Button
                styleButton="button-question"
                onClick={this.handleClickAnswerQuestion}
                isActive={this.props.answer === 'no'}
                icon={this.props.answer === 'no'}
                type="question"
                text={<Trans id="No" />}
                name="no"
                questionId={this.props.questionId}
              />
              <Button
                styleButton={this.state.isShow ? "button-comment d-flex flex-row justify-content-around" : "hide-element"}
                onClick={this.handleClickComment}
                icon={true}
                isShow={this.props.display}
                text={<Trans id="Comment" />}
                name="no"
                questionId={this.props.questionId}
              />
            </div>
            <CommentInput commentContent={this.state.commentContent} questionId={this.props.questionId} placeholder={this.props.i18n._(i18nMark('Comment'))} handleSave={this.handleSave} onChangeTextarea={this.onChangeTextarea} handleClickCancel={this.handleClickCancel} display={this.state.isShowComment} />
            <CommentItem isShowCommentItem={this.state.isShowCommentItem} editComment={this.handleClickComment} deleteComment={this.deleteComment} content={this.props.comment} />
          </div>
        </div>
      </div>
    );
  }
};
export default withI18n()(QuestionItem)


// WEBPACK FOOTER //
// ./src/screens/Question/components/QuestionItem/QuestionItem.js